import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'estTime'
})
export class EstTimePipe implements PipeTransform {

  transform(value: string | Date | number, format?: string): string {
    if (!value) {
      return '';
    }

    try {
      // Convert input to Date object
      const date = new Date(value);
      
      // Check if date is valid
      if (isNaN(date.getTime())) {
        return '';
      }

      // Convert to EST timezone
      const estDate = new Date(date.toLocaleString('en-US', {
        timeZone: 'America/New_York'
      }));

      // Format the date based on the format parameter
      if (format === 'short') {
        return estDate.toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric'
        });
      } else if (format === 'time') {
        return estDate.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
          timeZone: 'America/New_York'
        });
      } else if (format === 'datetime') {
        return estDate.toLocaleString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
          timeZone: 'America/New_York'
        });
      } else if (format === 'compact') {
        // Format: "8/8/25, 4:58 PM"
        return estDate.toLocaleString('en-US', {
          month: 'numeric',
          day: 'numeric',
          year: '2-digit',
          hour: 'numeric',
          minute: '2-digit',
          hour12: true,
          timeZone: 'America/New_York'
        });
      } else {
        // Default format: full date and time
        return estDate.toLocaleString('en-US', {
          timeZone: 'America/New_York'
        });
      }
    } catch (error) {
      console.error('Error converting date to EST:', error);
      return '';
    }
  }
}
